<template lang="pug">
p.text-center
  template(v-if="saving")
    i.ui.icon.suus-circle.loading.large
    div {{processedUploads}} von {{totalUploads}} Dateien wurden verarbeitet.
  template(v-else)
    sui-button(class="primary" @click="$emit('submit')" :class="{disabled: disabled}" size="big" v-if="uploadsCount > 0")
      | {{this.uploadsCount }} Dateien speichern
    template(v-if="saved")
      .ui.message.visible.success(v-if="savedUploads > 0") {{savedUploads}} Dateien wurden gespeichert.
      .ui.message.visible.error(v-if="failedUploads > 0") {{failedUploads}} Dateien konnten nicht gespeichert werden.
</template>

<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent(
    {
      name: 'DriveUploaderSubmit',
      props: {
        saving: {
          type: Boolean,
          default: false,
        },
        saved: {
          type: Boolean,
          default: false,
        },
        processedUploads: {
          type: Number,
          default: 0,
        },
        totalUploads: {
          type: Number,
          default: 0,
        },
        uploadsCount: {
          type: Number,
          default: 0,
        },
        savedUploads: {
          type: Number,
          default: 0,
        },
        failedUploads: {
          type: Number,
          default: 0,
        },
        disabled: {
          type: Boolean,
          default: true,
        },
      },
    }
)
</script>
